/* eslint-disable max-len */
import { GiftIcon } from '@phosphor-icons/react';
import { Checkbox, Flex, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import React, { useState } from 'react';
import { Image, Radio, Typography } from 'tfc-components';

import backupCard from 'assets/images/backup_card.jpg';
import logoEvol from 'assets/images/logo_evol.png';
import logoNgonluong from 'assets/images/nganluong-logo-color.png';
import mainCard from 'assets/images/primary_card.jpg';
import Button from 'components/atoms/Button';

function PaymentMethod() {
  /* States */
  const [usedCard, setUsedCard] = useState<'main' | 'backup'>('main');
  const [checked, setChecked] = useState(false);
  const [method, setMethod] = useState<'card' | 'other'>('card');

  const columns: ColumnsType<any> = [
    {
      title: 'Package',
      dataIndex: 'Package',
      key: 'Package',
      render: () => (
        <Typography.Text>Basic</Typography.Text>
      )
    },
    {
      title: 'Unit',
      dataIndex: 'Unit',
      key: 'Unit',
      render: () => (
        <Typography.Text>1</Typography.Text>
      )
    },
    {
      title: 'Duration',
      dataIndex: 'Duration',
      key: 'Duration',
      render: () => (
        <Typography.Text>Monthly</Typography.Text>
      )
    },
    {
      title: 'Unit Price (VND)',
      dataIndex: 'unitprice',
      key: 'unitprice',
      render: () => (
        <Typography.Text>10.000.000</Typography.Text>
      )
    },
    {
      title: 'Total (VND)',
      dataIndex: 'total',
      key: 'total',
      render: () => (
        <Typography.Text>120.000.000</Typography.Text>
      )
    }
  ];

  const components = {
    header: {
      // eslint-disable-next-line react/no-unstable-nested-components
      cell: (props: any) => (
        <th
          {...props}
          style={{
            backgroundColor: 'white',
            fontWeight: 'bold',
          }}
        />
      ),
    },
  };

  const fakeEmail = ['ketoan@abcsoft.vn', 'ketoan@abcsoft.vn', 'ketoan@abcsoft.vn', 'ketoan@abcsoft.vn'];

  return (
    <div className="p-paymentMethod">
      <div className="p-paymentMethod_container">
        <Image
          ratio={205 / 42}
          imgSrc={logoEvol}
          alt="Logo Ask2Auto"
          extendClasses="p-paymentMethod_logo"
        />

        <Flex gap={24}>
          <Flex vertical flex={2}>
            <div className="p-paymentMethod_product">
              <Typography.Text extendClasses="fs-20x24" fontweight="600">Product list</Typography.Text>

              <Table
                dataSource={[...Array.from({ length: 2 })]}
                columns={columns}
                components={components}
                pagination={false}
              />
              <div className="p-paymentMethod_totalWrap">
                <Flex flex={4}>
                  <Typography.Text fontweight="600">
                    Total
                  </Typography.Text>
                </Flex>

                <Flex flex={1} style={{ paddingInline: 20 }}>
                  <Typography.Text fontweight="600">
                    120.000.000
                  </Typography.Text>
                </Flex>
              </div>
            </div>

            <div className="p-paymentMethod_gift">
              <Flex align="center" gap={8}>
                <div className="p-paymentMethod_gift_iconWrap">
                  <GiftIcon size={20} />
                </div>
                <Typography.Text extendClasses="p-paymentMethod_gift_title">Extra Days</Typography.Text>
              </Flex>

              <Typography.Text extendClasses="p-paymentMethod_gift_description">
                Discount is converted into extra days, extending your plan duration.
              </Typography.Text>
            </div>

            <div className="p-paymentMethod_packageDetail">
              <Typography.Text fontweight="600" extendClasses="fs-20x24">Plan Overview</Typography.Text>

              <Typography.Text extendClasses="p-paymentMethod_packageDetail_description">
                By renewing this package, you will continue to use the same resources without interruption, starting from [renewal date]
                <br />
                Number of chatbots: X chatbots
                <br />
                Number of sessions: Y chatbot sessions
                <br />
                Knowledge base capacity: Z files, W websites, V MB storage and permission to access to all features included in the plan
              </Typography.Text>
            </div>

            <div className="p-paymentMethod_packageDetail">
              <Typography.Text fontweight="600" extendClasses="fs-20x24">Invoice Information</Typography.Text>

              <div className="p-paymentMethod_packageDetail_formInfo">
                <Flex vertical gap={6}>
                  <Typography.Text fontweight="600" extendClasses="fs-14x20">
                    Invoice Recipient Type
                  </Typography.Text>
                  <Typography.Text extendClasses="fs-14x20">
                    Business
                  </Typography.Text>
                </Flex>

                <Flex>
                  <Flex vertical flex={1} gap={6}>
                    <Typography.Text fontweight="600" extendClasses="fs-14x20">
                      Tax ID
                    </Typography.Text>
                    <Typography.Text extendClasses="fs-14x20">
                      0312345678
                    </Typography.Text>
                  </Flex>

                  <Flex flex={2} vertical gap={6}>
                    <Typography.Text fontweight="600" extendClasses="fs-14x20">
                      Company Name
                    </Typography.Text>
                    <Typography.Text extendClasses="fs-14x20">
                      Công Ty TNHH Giải Pháp Phần Mềm ABC
                    </Typography.Text>
                  </Flex>
                </Flex>

                <Flex vertical gap={6}>
                  <Typography.Text fontweight="600" extendClasses="fs-14x20">
                    Full Address
                  </Typography.Text>
                  <Typography.Text extendClasses="fs-14x20">
                    123 Nguyen Hue Street, Ben Nghe Ward, District 1, Ho Chi Minh City, Vietnam
                  </Typography.Text>
                </Flex>

                <Flex vertical gap={6}>
                  <Typography.Text fontweight="600" extendClasses="fs-14x20">
                    Invoice Email
                  </Typography.Text>
                  <div className="t-overview_listEmail">
                    {fakeEmail.map(
                      (email: string) => (
                        <div className="t-overview_email">
                          <Typography.Text>{email}</Typography.Text>
                        </div>
                      )
                    )}
                  </div>
                </Flex>
              </div>
            </div>
          </Flex>

          <Flex vertical flex={1.3} className="p-paymentMethod_cardInfo">
            <div className="p-paymentMethod_cardInfo_header">
              <Typography.Text extendClasses="fs-20x24" fontweight="600">Payment method</Typography.Text>
            </div>

            <div className="p-paymentMethod_cardInfo_body">
              <div>
                <Flex gap={4} align="center">
                  <Radio checked={method === 'card'} onClick={() => setMethod('card')} size={20} />
                  <Typography.Text fontweight="600" extendClasses="fs-14x20">Your card</Typography.Text>
                </Flex>
                {
                  method === 'card'
                  && (
                    <>
                      <Image
                        imgSrc={usedCard === 'main' ? mainCard : backupCard}
                        alt="primary-card"
                        ratio={310 / 171}
                        extendClasses="p-paymentMethod_cardInfo_cardImg"
                      />

                      <Button
                        onClick={() => {
                          if (usedCard === 'main') {
                            setUsedCard('backup');
                          } else {
                            setUsedCard('main');
                          }
                        }}
                        className="p-paymentMethod_cardInfo_btnTxt"
                        variant="transparent"
                      >
                        Use backup card
                      </Button>
                    </>
                  )
                }
              </div>

              <div className="p-paymentMethod_cardInfo_others">
                <Flex gap={4} align="center">
                  <Radio checked={method === 'other'} onClick={() => setMethod('other')} size={20} />
                  <Typography.Text fontweight="600" extendClasses="fs-14x20">Others</Typography.Text>
                </Flex>

                {
                  method === 'other' && (
                    <ul>
                      <li>JCB</li>
                      <li>Master Card</li>
                      <li>Visa</li>
                    </ul>
                  )
                }

              </div>
            </div>

            <div className="p-paymentMethod_cardInfo_total">
              <Flex justify="space-between">
                <Typography.Text>Total</Typography.Text>
                <Typography.Text extendClasses="p-paymentMethod_cardInfo_total_amount">{'{Amount}'}</Typography.Text>
              </Flex>

              <div className="p-checkout_confirmation_agreement">
                <Checkbox onChange={() => setChecked(!checked)} />
                <Typography.Text extendClasses="p-checkout_confirmation_agreementText">
                  I agree to Ask2Auto
                  {' '}
                  <span className="p-checkout_confirmation_link" onClick={() => window.open('/privacy-policy', '_blank')}>privacy policy</span>
                  {' '}
                  and
                  {' '}
                  <span className="p-checkout_confirmation_link" onClick={() => window.open('/terms-and-conditions', '_blank')}>terms</span>
                </Typography.Text>
              </div>

              <Button className="p-paymentMethod_cardInfo_payBtn">
                Select payment method
              </Button>

              <div className="p-paymentMethod_cardInfo_supportPayment">
                <Typography.Text>
                  Supported by payment gateway
                </Typography.Text>

                <Image extendClasses="p-paymentMethod_cardInfo_logoNganluong" imgSrc={logoNgonluong} alt="nganLuongImg" ratio={394 / 87} />
              </div>
            </div>

          </Flex>
        </Flex>
      </div>

      <div className="p-paymentMethod_footer">
        <div className="p-paymentMethod_container">
          <Button className="p-paymentMethod_footer_btn" variant="outline">
            Back
          </Button>
        </div>
      </div>
    </div>
  );
}

export default PaymentMethod;
